import React, { useState, useEffect } from 'react';
import MaterialTable, { MTableToolbar,MTableBody } from 'material-table';
import { TableCell, TableFooter, TableRow } from "@material-ui/core";
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import tableIcons from './tableIcons';
import ReactPaginate from 'react-paginate';
import VisibilityIcon from '@material-ui/icons/RemoveRedEyeOutlined';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import SearchIcon from '@material-ui/icons/Search';
import Button from '../Button';

import API from '../../../utils/api';
  
const getActions = {
  view: (action) => ({
    icon: () => <VisibilityIcon  color="secondary" fontSize="small"/>,
    tooltip: 'View History',
    onClick: (event, rowData) => {
       action(rowData)
    }
  }),
  delete: (action) => ({
    icon: () => <DeleteOutlineIcon color="secondary" fontSize="small"/>,
    tooltip: 'Delete',
    onClick: (event, rowData) => action(rowData)
  }),
  edit: (action) => ({
    icon: () => <EditOutlinedIcon color="secondary" fontSize="small"/>,
    tooltip: 'Edit',
    onClick: (event, rowData) => action(rowData)
  })  
}

const Table = ({ classes, url, onPageChange, isLoading = false, title="", tableConfig, data, onView, onDelete, onEdit,onVerify, noBorder = false, globalSearch = false, filtering = true ,key,apidata,countryid,btnlabel}) => {
  const [config, setConfig] = useState([]);
  const [localization, setLocale] = useState({});
  const [currency, setCurrency] = useState('');
  const [grandtotal, setGrandTotal] = useState('0');
  const [deliveryCharges, setDeliveryCharges] = useState('0');
  const [taxAmount, setTaxAmount] = useState('0');
  const [convenienceFees, setConvenienceFees] = useState('0');
  const [codAmount, setCodAmount] = useState('0');
  const [onlineAmount, setOnlineAmount] = useState('0');

  let actions = [];
  
  if(onView) {
    actions = [ ...actions, getActions.view(onView) ];
  }
  if(onEdit) {
    actions = [ ...actions, getActions.edit(onEdit) ];
  }
  if(onDelete) {
    actions = [ ...actions, getActions.delete(onDelete) ];
  } 
  
  const filterComponent = (props) => {
    return (<div> 
      <input type="text" placeholder="Search" className={classes.filter} onChange={
      (e)=> props.onFilterChanged(props.columnDef.tableData.id, e.target.value)
    }/></div>)
  };
  
  useEffect(()=>{
    if(tableConfig && tableConfig.columns) {
      const configuration = tableConfig.columns.map((configItem)=>{
        return {
          ...configItem,
          sorting: configItem.filterAndSearch,
          filtering: configItem.filterAndSearch,
          filterComponent: filterComponent,
          filterPlaceholder: 'Search',
          searchable: configItem.filterAndSearch
        }
      });
      setConfig(configuration);
    }
  }, [tableConfig]);

  return (
    <MaterialTable
      style={{ width: '100%', boxShadow: 'none', background: 'white', padding: '15px', borderRadius: noBorder ? '0px' : '5px' }}
      localization={localization}
      icons={tableIcons}
      actions={actions}
      columns={config}
      //data={data}
      title={title}
      isLoading={isLoading}
      
      options={
        {
          toolbar: globalSearch,
          filtering: filtering,
          sorting: true,
          hideFilterIcons: true,
          actionsColumnIndex: -1,
          tableLayout: 'fixed',
          searchFieldAlignment : 'left',
          pageSize: 5,
          paginationType: 'stepped',
          pageSizeOptions: [],
           headerStyle: { 
            backgroundColor: '#f58634', 
            color: 'white',
            padding: '8px 0 8px 16px',
          },
          filterCellStyle: { 
            backgroundColor: '#fef3ea',
            padding: '8px 0 8px 16px',            
          },
          searchFieldStyle: {
            borderRadius: '20px',
            border: '1px solid grey',
            padding: '5px 35px',
            marginBottom: '10px',
          }
        }
      }
    
      data={url ? query =>
        new Promise((resolve, reject) => {
          //console.log("apiquery",query);
          setLocale({ body: { emptyDataSourceMessage: '' } });
          let filters = [];
           let painationProps = [`recordsPerPage=5`, `pageNo=${query.page + 1}`];
           
          if(query.filters.length>0) {
            filters = query.filters.map(filter=> `${filter.column.field}=${filter.value}`);
          }
          let apiUrl = `${url}&`;
          let newdata = "";
          apiUrl+= [...filters, ...painationProps].join('&');
           // console.log("apiurl",apiUrl);
          API.get(apiUrl)
            .then(response => {
              let result = response.data || {};
              if(apidata === "records"){
                newdata = result.details.records;
               // console.log("newdata-sellerwise",result.details.records);
            if(result.details.totalInfo!=null || result.details.totalInfo!=""){
                setCurrency( result.details.totalInfo.currency);
                setGrandTotal( result.details.totalInfo.grandSalesAmount);
                setDeliveryCharges( result.details.totalInfo.deliveryCharges);
                setTaxAmount( result.details.totalInfo.taxAmount);
                setConvenienceFees( result.details.totalInfo.convenienceFees);
                setCodAmount( result.details.totalInfo.codAmount);
                setOnlineAmount( result.details.totalInfo.onlineAmount);
               }
               
              } 
          
 
            resolve({
                data: newdata,
                page: result.details.pageNo-1,
                totalCount: result.details.totalRecords,
              
            }) 
              setLocale({ body: { emptyDataSourceMessage: isLoading ? '' : 'No Records found' } });
            })
        }) : data
      }
      
     components={{
          Body: (props) => (
             <>
            <MTableBody {...props} />
              <TableFooter>
              <TableRow>
                <TableCell style={{fontWeight:"bold" }}>Total</TableCell>
                <TableCell style={{fontWeight:"bold" }}><div>{(currency === "&#8377;") ? <span>&#8377;{grandtotal}</span> : <span>&#36;{grandtotal}</span>}</div></TableCell>
                <TableCell style={{fontWeight:"bold" }}><div>{(currency === "&#8377;") ? <span>&#8377;{codAmount}</span> : <span>&#36;{codAmount}</span>}</div></TableCell>
                <TableCell style={{fontWeight:"bold" }}><div>{(currency === "&#8377;") ? <span>&#8377;{onlineAmount}</span> : <span>&#36;{onlineAmount}</span>}</div></TableCell>
                <TableCell style={{fontWeight:"bold" }}><div>{(currency === "&#8377;") ? <span>&#8377;{taxAmount}</span> : <span>&#36;{taxAmount}</span>}</div></TableCell>
                <TableCell style={{fontWeight:"bold" }}><div>{(currency === "&#8377;") ? <span>&#8377;{deliveryCharges}</span> : <span>&#36;{deliveryCharges}</span>}</div></TableCell>
                <TableCell style={{fontWeight:"bold" }}><div>{(currency === "&#8377;") ? <span>&#8377;{convenienceFees}</span> : <span>&#36;{convenienceFees}</span>}</div></TableCell>
              </TableRow>
             </TableFooter>
          </>
        )

      }} 
       />
  );
};

export default Table;
